import { render, staticRenderFns } from "./MantenimientoTable.vue?vue&type=template&id=366351d9&"
import script from "./MantenimientoTable.vue?vue&type=script&lang=js&"
export * from "./MantenimientoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports